module.exports = __webpack_public_path__ + "img/notProblem.bdd7271d.svg";